import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class PrevIcon extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20">
        <title>Previous</title>
        <path fillRule="nonzero"
          fill={this.props.active ? '#ffffff' : '#0092ff'}
          d="M10 0l4 4-6 6 6 6-4 4L0 10z" />
      </svg>
    );
  }
}

PrevIcon.propTypes = {
  active: PropTypes.bool
};
